import { render, staticRenderFns } from "./UserDisplayName.vue?vue&type=template&id=4bcd0f1c&scoped=true&"
import script from "./UserDisplayName.vue?vue&type=script&lang=js&"
export * from "./UserDisplayName.vue?vue&type=script&lang=js&"
import style0 from "./UserDisplayName.vue?vue&type=style&index=0&id=4bcd0f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcd0f1c",
  null
  
)

export default component.exports